const ROLES = [
  { key: "ROLE_OWNER", value: "Proprietário" },
  { key: "ROLE_OPERATIONAL", value: "Operacional" },
  { key: "ROLE_CASHIER", value: "Caixa" }
];

export default ROLES;
